<template>
  <div class="search-tab-col">
    <form action="listing-grid-sidebar" method="post">
      <div class="row align-items-center search-form">
        <div class="col-12 col-lg-11 datepicker-col search-group">
          <ul class="gap-3 d-flex">
            <li>
              <div class="car-search-grid d-flex">
                <div class="flex-shrink-0 d-flex align-items-center">
                  <div class="icon-blk rounded-circle">
                    <i class="feather-map-pin"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <span class="label">Location</span>
                  <input
                    type="text"
                    name="name"
                    class="border-0 text-truncate px-0 form-control"
                    placeholder="Newyork, USA"
                  />
                </div>
              </div>
            </li>
            <li>
              <div class="car-search-grid d-flex">
                <div class="flex-shrink-0 d-flex align-items-center">
                  <div class="icon-blk rounded-circle">
                    <i class="feather-pie-chart"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <span class="label">Make</span>
                  <input
                    type="text"
                    name="checkin"
                    class="border-0 text-truncate px-0 form-control datetimepicker"
                    placeholder="28/12/2022"
                  />
                </div>
              </div>
            </li>
            <li>
              <div class="car-search-grid d-flex">
                <div class="flex-shrink-0 d-flex align-items-center">
                  <div class="icon-blk rounded-circle">
                    <i class="feather-refresh-ccw"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <span class="label">Models</span>
                  <input
                    type="text"
                    name="checkout"
                    class="border-0 text-truncate px-0 form-control datetimepicker"
                    placeholder="28/12/2022"
                  />
                </div>
              </div>
            </li>
            <li>
              <div class="car-search-grid d-flex">
                <div class="flex-shrink-0 d-flex align-items-center">
                  <div class="icon-blk rounded-circle">
                    <i class="feather-tag"></i>
                  </div>
                </div>
                <div class="flex-grow-1 ms-3">
                  <span class="label">Prices</span>
                  <input
                    type="text"
                    name="mobile"
                    class="border-0 text-truncate px-0 form-control"
                    placeholder="Benz C class"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-12 col-lg-1 car-search-btn">
          <button class="btn car-search-icon">
            <img src="@/assets/img/icons/white-search.svg" alt="" />
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
